import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useRetailerQuery } from './retailer.generated';
import { clsx } from 'clsx';
import { useSetAtom } from 'jotai';
import { CategoryFilter } from '@/components/CategoryFilter';
import { InventoryCarousel } from '@/components/InventoryCarousel';
import { InventorySorting } from '@/components/InventorySorting';
import { InventoryCatalog } from '@/components/IventoryCatalog';
// temporary
import useArticlesPagination from '@/components/IventoryCatalog/useArtclesPagination';
import { RetailerInfo } from '@/components/RetailerInfo';
import { TopInfoSearchBar } from '@/components/TopInfoSearchBar';
import { isReroderWarningEnabled } from '@/store/atoms';
import { RetailerInfoType } from '@/store/types';
import { Article, Retailer } from '@/types';

type RetailerParams = {
  retailerId: string;
};

const handleSearchParams = (param, paramValue) => {
  const url = new URL(window.location.href);

  if (!paramValue) {
    url.searchParams.delete(param);
  } else {
    url.searchParams.set(param, paramValue);
  }

  const newQueryString = url.searchParams.toString();
  const newUrl =
    url.origin + url.pathname + (newQueryString ? '?' + newQueryString : '');
  window.history.pushState({}, '', newUrl);
};

const RetailerPage = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [category_id, setCategoryId] = useState<string | null>(null);
  const { retailerId } = useParams() as RetailerParams;
  const setReorderWarningEnabled = useSetAtom(isReroderWarningEnabled);

  const handleSearchTermValue = (term: string) => {
    handleSearchParams('term', term);
    setSearchTerm(term);
  };

  const handleTaxonomyChange = (id: number) => {
    handleSearchParams('category_id', id);
    setCategoryId(`${id}`);
  };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const term = params.get('term');
    const categoryId = params.get('category_id');
    if (term) {
      setSearchTerm(term);
    }
    if (categoryId) {
      setCategoryId(categoryId);
    }
  }, []);

  const [result] = useRetailerQuery({
    variables: {
      retailerId: retailerId,
    },
  });

  setReorderWarningEnabled(
    result.data?.retailer.settings.reorderArticles || false,
  );

  // need seperate query for carousel
  // thats why the import is from far away, this is temporrary
  const { inventoryResult: carouselResult } = useArticlesPagination({
    retailerId: retailerId,
    categoryId: '1',
    perPage: 21,
  });

  if (!result.data?.retailer) {
    return null;
  }
  return (
    <>
      <TopInfoSearchBar
        retailerInfo={result.data.retailer as RetailerInfoType}
        setSearchTerm={handleSearchTermValue}
        searchTerm={searchTerm}
      />
      <div className="my-2-0">
        <div className="flex">
          {/* left side */}
          <div id="left-side" className="hidden md:block min-w-[36rem] pl-2-0">
            <CategoryFilter
              setSelectedCategoryId={handleTaxonomyChange}
              category_id={category_id}
              className="fixed"
            />
          </div>
          {/* right side */}
          <div
            id="right-side"
            className="flex flex-col py-2-0 md:py-0 md:ml-[]"
          >
            <>
              <div
                className={clsx(
                  searchTerm ? 'max-h-0' : 'max-h-100-0',
                  'transition-all duration-300 ease-in overflow-hidden',
                )}
              >
                <RetailerInfo retailer={result.data.retailer as Retailer} />
                <InventoryCarousel inventory={carouselResult as Article[]} />
              </div>
              <InventorySorting />
              <InventoryCatalog
                searchTerm={searchTerm}
                categoryId={category_id}
              />
            </>
          </div>
        </div>
      </div>
    </>
  );
};

export default RetailerPage;
